import LexoRank from '@kayron013/lexorank';

export function dragAndDropChangeRank<Type extends { rank: string }>(
  list: Type[],
  currentIndex: number,
  previousIndex: number
): string {
  if (currentIndex > list.length - 1) {
    currentIndex = list.length - 1;
  }
  if (!list[currentIndex].rank) {
    // todo debemos de agregar posibilidad de aun asignar un rank
    return null;
  }
  let split = list[currentIndex].rank.split('|');
  const oldRank = new LexoRank(split[1], split[0]);

  if (currentIndex === 0) {
    return oldRank.decrement().toString();
  }
  if (currentIndex === list.length - 1) {
    return oldRank.increment().toString();
  }

  let indexForBetween =
    currentIndex > previousIndex ? currentIndex + 1 : currentIndex - 1;
  indexForBetween = Math.max(0, indexForBetween);

  let betweenRank = list[indexForBetween]?.rank;
  const previousRank = list[previousIndex]?.rank;

  if (previousRank === betweenRank) {
    betweenRank = list[currentIndex + 1]?.rank;
  }

  if (!betweenRank) {
    return oldRank.decrement().toString();
  }
  if (betweenRank === list[list.length - 1].rank) {
    return oldRank.increment().toString();
  }
  split = betweenRank.split('|');

  const oldRankHigher = new LexoRank(split[1], split[0]);

  // En caso de que se mueva el item entre dos items de ranks iguales,
  // haremos una solucion donde pondremos nuestro item al top de los valores iguales o al bottom
  // dependiendo el tipo de movimiento que hizo el usuario.
  if (oldRankHigher.toString() === oldRank.toString()) {
    return currentIndex > previousIndex
      ? oldRank.increment().toString()
      : oldRank.decrement().toString();
  }
  const newRank =
    currentIndex > previousIndex
      ? LexoRank.between(oldRank, oldRankHigher)
      : LexoRank.between(oldRankHigher, oldRank);
  return newRank.toString();
}
